<hr>
<h2>Edit Delivery For Fee</h2><button class="cancel btn btn-warning" (click)="goBack()">Cancel</button>
<hr>
<div >
    <form name="form" [formGroup]="myForm" (ngSubmit)="updateDeliveryForFee()" novalidate>
        <div class="form-group" >
                <input type="hidden" class="form-control" id="id" formControlName="id" required />
        </div>
    <div class="form-group">
            @if (myForm.get('productcode')?.invalid) 
            {
                @if (productcode?.errors?.['required']) {
                        <div class="help-block">
                            Product Code is required.
                        </div>
                }
                @if (productcode?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            productcode has too many characters.
                    </div>
                }
            }            
            <label for="productcode">Product Code</label>
            <select id="productcode" formControlName="productcode" required >
                @for (product of products; track product.productcode) {
                    <option [ngValue]="product.productcode">{{product.description}}</option>
                }
            </select>
    </div>
    <div class="form-group">
                <label for="returndocno">Return Doc No/Invoice No</label>
                                @if (myForm.get('returndocno')?.invalid) 
                    {
                        @if (returndocno?.errors?.['pattern']) 
                        {
                            <div class="help-block">
                               Return Doc No must be a valid format.
                            </div>
                        }
                        @if (returndocno?.errors?.['required']) 
                        {
                            <div class="help-block">
                                Return Doc No is required.
                            </div>
                        }
                    }
                <input type="text" class="form-control" id="returndocno" formControlName="returndocno" required />
        </div>
        <div class="form-group">
            <label for="returndate">Return Date</label>
                                @if (myForm.get('returndate')?.invalid) 
                    {
                        @if (returndate?.errors?.['pattern']) 
                        {
                            <div class="help-block">
                               Return Date must be a valid format.
                            </div>
                        }
                        @if (returndate?.errors?.['required']) 
                        {
                            <div class="help-block">
                                Return Date is required.
                            </div>
                        }
                    }            
            <input type="date" class="form-control" id="returndate" formControlName="returndate" required/>        
        </div>
        <div class="form-group">
                    @if (myForm.get('warehousecode')?.invalid) 
                    {
                        @if (warehousecode?.errors?.['pattern']) 
                        {
                            <div class="help-block">
                               Warehouse Code must be a valid format.
                            </div>
                        }
                        @if (warehousecode?.errors?.['required']) 
                        {
                            <div class="help-block">
                                Warehouse Code is required.
                            </div>
                        }
                    }            
            <label for="warehousecode">Warehouse Code</label>
            <select id="warehousecode" formControlName="warehousecode" required >
                @for (warehousecode of warehousecodes; track warehousecode.warehousecode) {
                    <option [ngValue]="warehousecode.warehousecode">{{warehousecode.description}}</option>
                }
                 </select>        
        </div>
        <div class="form-group" >
            <label for="dffvolume">Volume Sold</label>
            @if (myForm.get('dffvolume')?.invalid) 
                    {
                        @if (dffvolume?.errors?.['pattern']) 
                        {
                            <div class="help-block">
                               Volume Sold must be a valid format.
                            </div>
                        }
                        @if (dffvolume?.errors?.['required']) 
                        {
                            <div class="help-block">
                                Volume Sold is required.
                            </div>
                        }
            }            
            <input type="text" class="form-control" id="dffvolume" formControlName="dffvolume" required />
        </div>
        <div class="form-group">
           @if (myForm.get('volumeid')?.invalid) 
            {
                @if (volumeid?.errors?.['required']) 
                {
                            <div class="help-block">
                                Volume ID is required.
                            </div>
                }
            }
            <label for="volumeid">Volume ID (B,L,P or C)</label>
            <select id="volumeid" formControlName="volumeid" required>
                <option value="B">Base Unit of Measure</option>
                <option value="L">Litre</option>
                <option value="P">Pack</option>
                <option value="C">Case</option>
            </select>
        </div>
        <div class="form-group" >
            <label for="lineno">Line No</label>
           @if (myForm.get('lineno')?.invalid) 
                    {
                        @if (lineno?.errors?.['pattern']) 
                        {
                            <div class="help-block">
                               Line No must be a valid format.
                            </div>
                        }
                        @if (lineno?.errors?.['required']) 
                        {
                            <div class="help-block">
                                Line No is required.
                            </div>
                        }
            }            
            <input type="text" class="form-control" id="lineno" formControlName="lineno" required />
        </div>
        <div class="form-group">
             @if (myForm.get('customercode')?.invalid) {
                @if (customercode?.errors?.['maxlength']) {
                    <div class="help-block">
                        Customer Code has too many characters.
                    </div>
                }
                @if (customercode?.errors?.['required']) {
                    <div class="help-block">
                        Customer Code is required.
                    </div>
                }
            }
            <label for="customercode">Customer Code (optional)</label>
            <select id="customercode" formControlName="customercode" required >
                @for (customercode of customercodes; track customercode.customercode) {
                    <option value = {{customercode.customercode}}>{{customercode.customername}}</option>
                }
            </select>
        </div>
        <div class="form-group" >
                <label for="uploaded">Date Uploaded: {{ uploaded?.value == '0000-00-00' ? 'Pending' : (uploaded?.value | date: 'MM/dd/yyyy') }}</label>
        </div>
        <div class="form-group">
            <button type="submit" [disabled]="myForm.invalid" class="btn btn-primary">Update</button>
        </div>
    </form>
    
</div>
